import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getToken } from '../utils/auth';

const AdminServiceForm = ({ onSaved, editingItem = null }) => {
  const [form, setForm] = useState({
    title: '',
    description: '',
    link: '',
    price: '',
    image: null,
  });

  useEffect(() => {
    if (editingItem) {
      setForm({
        title: editingItem.title || '',
        description: editingItem.description || '',
        link: editingItem.link || '',
        price: editingItem.price ?? '',
        image: null,
      });
    } else {
      setForm({ title: '', description: '', link: '', price: '', image: null });
    }
  }, [editingItem]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setForm((prev) => ({ ...prev, [name]: files ? files[0] : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) => {
      if (v === null || v === undefined) return;
      if (k === 'price' && v === '') return;
      fd.append(k, v);
    });

    try {
      if (editingItem) {
        await axios.put(`${process.env.REACT_APP_API_URL}/api/services/${editingItem.id}` , fd, {
          headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${getToken()}` },
        });
      } else {
        await axios.post(`${process.env.REACT_APP_API_URL}/api/services`, fd, {
          headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${getToken()}` },
        });
      }
      onSaved?.();
      setForm({ title: '', description: '', link: '', price: '', image: null });
    } catch (err) {
      console.error('Service save failed', err);
      alert('Failed to save service');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mb-4">
      <h4>{editingItem ? 'Edit Service' : 'Add Service'}</h4>
      <div className="row g-2">
        <div className="col-md-6">
          <input type="text" className="form-control" name="title" placeholder="Title" value={form.title} onChange={handleChange} required />
        </div>
        <div className="col-md-6">
          <input type="text" className="form-control" name="link" placeholder="Link (e.g. /rooms/deluxe)" value={form.link} onChange={handleChange} />
        </div>
      </div>

      <textarea className="form-control mt-2" name="description" placeholder="Description" value={form.description} onChange={handleChange} required />

      <div className="row g-2 mt-1">
        <div className="col-md-4">
          <input type="number" step="0.01" className="form-control" name="price" placeholder="Price (USD)" value={form.price} onChange={handleChange} />
        </div>
        <div className="col-md-8">
          <input type="file" accept="image/*" className="form-control" name="image" onChange={handleChange} />
        </div>
      </div>

      <div className="d-flex mt-3">
        <button type="submit" className="btn btn-success me-2">Save</button>
      </div>
    </form>
  );
};

export default AdminServiceForm;
